import { makeStyles, useMediaQuery } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import FaqComponent from "../../RedesignedComponents/FaqComponent";

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
        '& h1': {
            margin: '0 0 2rem 0'
        },
        '& h5': {
            lineHeight: '1.4',
            fontSize: '0.95rem',
            textAlign: 'start',
            margin: '0'
        },
    },
    mainContentWidth: {
        width: '100%',
        display: 'flex',
        margin: 'auto',
        gap: '1rem',
        '& > div': {
            [theme.breakpoints.down('xs')]: {
                width: '100%',
            },
            width: '50%',
        }
    }
}))

const TracksFAQs = ({ faqs, ...props }) => {

    const classes = useStyles();
    const isSMScreen = useMediaQuery((theme) => theme.breakpoints.down('xs'));
    const minSizeToDivide = 5;
    const [dividedFaqs, setDividedFaqs] = useState([]);

    useEffect(() => {
        getDividedFaqs();
    }, [isSMScreen])

    const getDividedFaqs = () => {
        if (isSMScreen) {
            setDividedFaqs([faqs]);
            return;
        }
        const newDividedFaqs = [];
        if (faqs.length > minSizeToDivide) {
            for (let i = 0; i < faqs.length; i = i + minSizeToDivide) {
                newDividedFaqs.push(faqs.slice(i, i + minSizeToDivide));
            }
            setDividedFaqs(newDividedFaqs);
        }
    }

    return (
        <section className={classes.root}>
            <h1>FAQ</h1>
            <div className={classes.mainContentWidth}>
                {
                    dividedFaqs.map((value, idx) =>
                        <div>
                            <FaqComponent
                                faqs={value}
                                scrollClass={props.customScroll}
                                key={idx + 'track faqs'}
                            />
                        </div>
                    )
                }
            </div>
        </section>
    )
}

export default TracksFAQs;